export enum RoleEnum {
  'authenticated'= 'authenticated',
  'administrator'= 'administrator',
  'staff' = 'staff'
}
